export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '__TRANSCRIPT': 'Transcript',
    '__SXS_TRANSCRIPT': 'SxS Transcript',
    '__CALL_TRANSCRIPT': 'Call Transcript'
};
